import React, { useEffect, useMemo } from 'react';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';
import { CITY_CENTER, areaCoords } from '../lib/geo';

const areaIcon = L.divIcon({
  className: '',
  html: '<div style="width:24px;height:24px;background:#C1440E;border:3px solid #fff;border-radius:50% 50% 50% 0;transform:rotate(-45deg);box-shadow:0 2px 8px rgba(0,0,0,.45)"></div>',
  iconSize: [24, 24], iconAnchor: [12, 24], popupAnchor: [0, -24],
});

function FitBounds({ points }) {
  const map = useMap();
  useEffect(() => {
    if (!points || !points.length) return;
    if (points.length === 1) { map.setView(points[0], 12); return; }
    map.fitBounds(points, { padding: [50, 50], maxZoom: 12 });
  }, [points, map]);
  return null;
}

const CommunitiesMap = ({ areas }) => {
  const data = useMemo(() => {
    const markers = [];
    (areas || []).forEach((a) => {
      const c = areaCoords(a.name);
      if (!c) return;
      markers.push({ name: a.name, count: a.count, pos: [c.lat, c.lng] });
    });
    const points = markers.map((m) => m.pos);
    const center = points.length ? points[0] : [CITY_CENTER.Dubai.lat, CITY_CENTER.Dubai.lng];
    return { markers, points, center };
  }, [areas]);

  return (
    <div className="relative z-0 rounded-2xl overflow-hidden border border-gobra-sand" style={{ height: 560 }} data-testid="communities-map">
      <MapContainer center={data.center} zoom={10} scrollWheelZoom={false} style={{ height: '100%', width: '100%' }}>
        <TileLayer
          attribution='Tiles &copy; <a href="https://www.esri.com/">Esri</a> &mdash; Esri, HERE, Garmin, OpenStreetMap contributors'
          url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}"
        />
        <FitBounds points={data.points} />
        {data.markers.map((m) => (
          <Marker key={m.name} position={m.pos} icon={areaIcon}>
            <Popup>
              <Link to={`/areas/${encodeURIComponent(m.name)}`} className="font-semibold text-gobra-terracotta" data-testid={`communities-map-popup-${m.name}`}>
                {m.name}
              </Link>
              <br />
              <span className="inline-flex items-center gap-1 text-xs text-gobra-slate">
                <MapPin className="h-3 w-3" /> {m.count} {m.count === 1 ? 'project' : 'projects'}
              </span>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};

export default CommunitiesMap;
